import { Component, input, output } from '@angular/core';
import { IconComponent } from '@shared/components/icon/icon.component';
import { TStatusBadge, TStatusBadgeColorScheme } from '@shared/components/status-badge/status-badge.interface';
import { StatusBadgeComponent } from '../status-badge/status-badge.component';

@Component({
  imports: [StatusBadgeComponent, IconComponent],
  selector: 'app-selectable-status-badge',
  templateUrl: './selectable-status-badge.component.html',
})
export class SelectableStatusBadgeComponent {
  public status = input.required<TStatusBadge>();
  public colorScheme = input<TStatusBadgeColorScheme>('campaign');
  public selected = input<boolean>(false);
  public disabled = input<boolean>(false);

  public selectionChanged = output<boolean>();

  public onToggle(): void {
    if (this.disabled()) {
      return;
    }

    this.selectionChanged.emit(!this.selected());
  }
}
